import callApi from "./callApi";
export const getConfigurations = async (entityType, projectId) => {
  const url = `plugin/entities/${entityType}?projectId=${projectId}`;
  return await callApi(url, {}, "GET");
};

export const addEntity = async (entity, currentProject) => {
  const url = `plugin/entities?projectId=${currentProject}`;
  return await callApi(url, {}, "POST", entity);
};

export const updateEntity = async (id, entity) => {
  const url = `plugin/entities/${id}`;
  return await callApi(url, {}, "PUT", entity);
};

export const deleteEntity = async (id) => {
  const url = `plugin/entities/${id}`;
  return await callApi(url, {}, "DELETE");
};

export const getTestCaseData = async (projectId) => {
  const url = `testcases/test-case-data?projectId=${projectId}`;
  return await callApi(url, {}, "GET");
};

export const getTestCycleData = async (projectId) => {
  const url = `testcycles/test-cycle-data?projectId=${projectId}`;
  return await callApi(url, {}, "GET");
};

export const checkEntityBeforeDelete = async (entityId) => {
  const url = `testcases/entities/check-before-delete/${entityId}`;
  return await callApi(url, {}, "GET");
}

export const getFieldConfigurations = async (projectId) => {
  const url = `configurations?projectId=${projectId}`;
  return await callApi(url, {}, "GET");
};

export const addField = async (payload) => {
  const url = `configurations`;
  const body = {
    ...payload
  }
  return await callApi(url, {}, "POST", body);
};

export const updateField = async (id, payload) => {
  const url = `configurations/update/${id}`;
  const body = {
    ...payload
  }
  return await callApi(url, {}, "PUT", body);
}

export const deleteField = async (id) => {
  const url = `configurations/delete/${id}`;
  return await callApi(url, {}, "DELETE");
};


